import { t } from "i18next";
import * as yup from "yup";
const areas = ["infants", "elderly", "disabled", "housework", "cooking"];

export const schema1 = (t) => yup.object().shape({
        name: yup.string().trim().optional(),
        imgprofile: yup.mixed().nullable().notRequired(),
        /* .test("fileSize", "File is too large (max 2MB)", value => {
             return value && value instanceof File && value.size <= FILE_SIZE;
           })*/

        //dob: yup.date().required("Date of birth is required"),
        dob: yup.string().required(t("Date of birth is required")).transform((value) => (value === "" ? null : value)),
        pob: yup.string().notRequired(),//required("Place of birth is required"),
        nationality: yup.string().notRequired(),//required("Nationality is required"),



        address: yup.string().notRequired(),//.required("Address is required"),
        airport: yup.string().notRequired(),//required("Port/Airport is required"),

        //contact: yup.string().matches(/^\d+$/).required("Contact number is required"),
        contact: yup.string()
        .notRequired()
        .transform((value, originalValue) => originalValue === "" ? undefined : value)
        .test('is-valid-phone', t('Please enter a valid international phone number that starts with +'), (value) => {
          if (!value) return true; // if empty or undefined, skip validation
          return /^\+\d{1,4}\d{6,14}$/.test(value); // otherwise, validate
        }),

        children: yup.number().min(0).default(0),
        children_age: yup.array()
            .of(
              yup.number()
                .typeError(t('Age must be a number'))
                .notRequired()
                .min(0, t('Minimum age is 0'))
                .max(120, t('Maximum age is 120'))
            )
            .notRequired(),

        age: yup
            .number()
            .transform((value, originalValue) => {
                if (originalValue === "") return undefined;

                // Use regex to test if the input is a valid number string
                if (typeof originalValue === "string" && !/^\d+(\.\d+)?$/.test(originalValue)) {
                    return NaN;
                }

                return Number(originalValue);
            })
            .typeError(t("Age must be a number"))
            .min(18, t("Minimum age is 18"))
            .notRequired(),
        height: yup
            .number()
            .transform((value, originalValue) => {
                if (originalValue === "") return undefined;
                if (typeof originalValue === "string" && !/^\d+(\.\d+)?$/.test(originalValue)) {
                    return NaN;
                }
                return Number(originalValue);
            })
            .typeError(t("Height must be a number"))
            .min(120, t("Minimum height is 120 cm"))
            .notRequired(),

        weight: yup
            .number()
            .transform((value, originalValue) => {
                if (originalValue === "") return undefined;
                if (typeof originalValue === "string" && !/^\d+(\.\d+)?$/.test(originalValue)) {
                    return NaN;
                }
                return Number(originalValue);
            })
            .typeError(t("Weight must be a number"))
            .min(40, t("Minimum weight is 40 kg"))
            .notRequired(),
        siblings: yup.number().transform((value, originalValue) =>
            originalValue === "" ? undefined : value
        ).min(0).default(0),
        education: yup.string().notRequired(),//required("Education level is required"),
        religion: yup
            .string().notRequired(),
       

        marital: yup
            .string()
            //.oneOf(["Single", "Married", "Divorced", "Widowed", "Separated"], "Marital status is required")
            .notRequired(),
        passport: yup.string().notRequired().default(""),
        passport_check: yup.boolean().default(false),
        salary: yup.string().notRequired(),
        code: yup.string()
  .notRequired()
  .test(
    'is-valid-ref',
    t('Reference Number must be between 4 and 32 characters long.'),
    value => !value || (typeof value === 'string' && value.length >= 4 && value.length <= 32)
  )


    });
    export   const schema2 = (t) => yup.object().shape({
        illnesses: yup.array().notRequired(),
        allergies: yup.string().notRequired(),
        disabilities: yup.string().notRequired(),
        illness_other: yup.string().notRequired(),

        rest_day: yup.string().notRequired(),
        remarks: yup.string().notRequired(),

        food_preference: yup.object({
            pork: yup.boolean().default(false),
            beef: yup.boolean().default(false),
            other: yup.string().notRequired().max(100, t("Too long")),
        }),
    });




    export  const schema3 = (t) => yup.object().shape({
        foreign_training_centre: yup.string().notRequired(),
        other_skills: yup.string().notRequired(),
        certification: yup.string().notRequired(),
        overseas_training: yup.boolean().default(false),
        interview_method: yup.array().notRequired().default([]),//min(1, "You must select at least one interview method").required("Interview Method is required"),
        singapore_ea: yup.boolean().default(false),
        fdw_declaration: yup.boolean().default(false),
        //skills: yup.array().optional(),
        //employment: yup.array().optional(),

          areas_of_work: yup.object(
    areas.reduce((acc, key) => {
      acc[key] = yup.object().shape({
        willing: yup.boolean(),
        experience: yup.boolean(),
        experience_years: yup.number().transform((value, originalValue) =>
    String(originalValue).trim() === "" ? undefined : value
  )
  .notRequired()
  .min(0, t("Years of experience must be zero or more")),
        rating: yup.string().notRequired(),
         
        extra: yup.string().notRequired(),
      });
      return acc;
    }, {})
  ),

    });
  export  const schema4 = (t) => yup.object().shape({



        interview_availability: yup.array().notRequired().default([]),//yup.array().min(1, "You must select at least one interview availability").required("Interview Availability is required"),
        feedback_employer_1: yup.string().notRequired(),
        feedback_employer_2: yup.string().notRequired(),

        //skills: yup.array().optional(),
        employment: yup.lazy((value) =>
            Array.isArray(value)
                ? yup.array().of(
                    yup.object().shape({
                        employment_from: yup.string(),
                        employment_to: yup.string(),
                        employment_country: yup.string(),
                        employment_employer: yup.string(),
                        employment_duties: yup.string(),
                    })
                )
                : yup.mixed().notRequired()
        ),
        singapore_experience: yup.string().notRequired(),
        other_remarks: yup.string().notRequired(),
    });
